import React from "react";
import styles from "./attendee.module.css";
import { Col, List, Row } from "antd";
import { MdCall } from "react-icons/md";
import { CgMenuBoxed } from "react-icons/cg";
import { TextComponent } from "../../../../../components";
import { BsFillChatLeftTextFill, BsTelephone } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import { IoMailOutline } from "react-icons/io5";
import { LocIcon, DiningIcon } from "../../../../../components/icons/Icons";
import { BiFoodMenu } from "react-icons/bi";
import { GrNotes } from "react-icons/gr";
import { RiFileList3Line } from "react-icons/ri";
import { useLocation } from "react-router-dom";

// const MealIcon = ({ className }) => {
//   return (
//     <svg
//       className={className}
//       viewBox="0 0 26 26"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M19.7772 0.0929687V2.06641C19.7772 2.62829 19.3112 3.09424 18.7493 3.09424C18.1875 3.09424 17.7215 2.62829 17.7215 2.06641V0.0107422H8.81364V2.06641C8.81364 2.62829 8.34769 3.09424 7.78581 3.09424C7.22393 3.09424 6.75798 2.62829 6.75798 2.06641V0.0929687C2.71517 0.462988 0.933594 3.06683 0.933594 6.86296V18.5117C0.933594 22.623 2.98926 25.3639 7.78581 25.3639H18.7493C23.5459 25.3639 25.6016 22.623 25.6016 18.5117V6.86296C25.6016 3.06683 23.82 0.462988 19.7772 0.0929687ZM13.2676 18.1691H7.78581C7.22393 18.1691 6.75798 17.7032 6.75798 17.1413C6.75798 16.5794 7.22393 16.1134 7.78581 16.1134H13.2676C13.8295 16.1134 14.2954 16.5794 14.2954 17.1413C14.2954 17.7032 13.8295 18.1691 13.2676 18.1691ZM18.7493 11.3169H7.78581C7.22393 11.3169 6.75798 10.8509 6.75798 10.2891C6.75798 9.72718 7.22393 9.26123 7.78581 9.26123H18.7493C19.3112 9.26123 19.7772 9.72718 19.7772 10.2891C19.7772 10.8509 19.3112 11.3169 18.7493 11.3169Z"
//         fill="var(--primary-color)"
//       />
//     </svg>
//   );
// };

// const TableIcon = ({ className }) => {
//   return (
//     <svg
//       className={className}
//       viewBox="0 0 29 29"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M17.2617 28.2886C15.4836 28.2886 13.7048 28.2886 11.9267 28.2886C11.9042 28.2749 11.883 28.2538 11.8585 28.2484C10.3728 27.9088 9.59422 26.7048 9.90649 25.2205C10.0333 24.6191 10.169 24.0192 10.3094 23.381C8.71197 23.381 7.14043 23.381 5.54297 23.381C5.54297 21.7842 5.54297 20.2215 5.54297 18.6398C4.90413 18.7802 4.29528 18.9166 3.68507 19.0468C2.08421 19.3884 0.669476 18.2675 0.659249 16.6373C0.649704 15.1135 0.650386 13.589 0.659249 12.0652C0.668795 10.4309 2.07739 9.30935 3.67894 9.65025C4.29665 9.78184 4.91299 9.92024 5.55934 10.0621C5.55934 8.46801 5.55934 6.90192 5.55934 5.31265C7.14929 5.31265 8.7147 5.31265 10.3087 5.31265C10.1622 4.64857 10.0142 4.01518 9.88262 3.37838C9.57104 1.86479 10.6749 0.439148 12.2035 0.416648C13.7996 0.393467 15.3963 0.40574 16.9924 0.414603C17.5447 0.418012 18.0451 0.608234 18.4644 0.968224C19.2839 1.67252 19.5089 2.56363 19.2628 3.59792C19.1299 4.15836 19.0105 4.72153 18.8776 5.31537C20.4798 5.31537 22.0445 5.31537 23.6338 5.31537C23.6338 6.90601 23.6338 8.47142 23.6338 10.0614C24.289 9.91683 24.9149 9.77365 25.5429 9.6407C26.6706 9.40207 27.773 9.92501 28.2714 10.945C28.3846 11.1768 28.446 11.4345 28.5312 11.6806C28.5312 13.4595 28.5312 15.2383 28.5312 17.0171C28.5135 17.0669 28.491 17.1153 28.4787 17.1657C28.2428 18.1421 27.6414 18.7645 26.6746 19.0373C26.1285 19.1913 25.5988 19.0788 25.067 18.9548C24.5972 18.8457 24.1254 18.7454 23.6209 18.6343C23.6209 20.2434 23.6209 21.8074 23.6209 23.3946C22.0316 23.3946 20.4682 23.3946 18.8817 23.3946C19.0262 24.0485 19.1694 24.6744 19.3017 25.3016C19.5396 26.4273 19.016 27.5304 17.9967 28.0281C17.7649 28.142 17.5072 28.2034 17.2617 28.2886ZM13.7675 2.04751C13.2316 2.04751 12.7244 2.03115 12.2191 2.05228C11.7617 2.07137 11.3976 2.47295 11.4753 2.91544C11.6151 3.71519 11.8053 4.50676 11.973 5.29356C12.59 5.29356 13.1743 5.29356 13.7682 5.29356C13.7675 4.2095 13.7675 3.14316 13.7675 2.04751ZM26.8908 13.527C26.8908 12.9808 26.914 12.4558 26.884 11.9343C26.8574 11.4809 26.4428 11.1727 25.9867 11.2293C25.7631 11.2572 25.5422 11.3111 25.3213 11.3602C24.7595 11.485 24.1984 11.6131 23.6536 11.7359C23.6536 12.3543 23.6536 12.9386 23.6536 13.527C24.7342 13.527 25.7938 13.527 26.8908 13.527ZM17.2126 5.30105C17.381 4.51903 17.5624 3.74383 17.7097 2.9618C17.7888 2.53977 17.5133 2.11774 17.0954 2.07887C16.5431 2.02774 15.9827 2.0666 15.4331 2.0666C15.4331 3.15475 15.4331 4.2279 15.4331 5.30105C16.0331 5.30105 16.612 5.30105 17.2126 5.30105ZM5.54843 11.7297C4.75959 11.5606 3.97756 11.3745 3.18668 11.232C2.76942 11.157 2.35147 11.4577 2.31807 11.8709C2.27375 12.4163 2.30716 12.9672 2.30716 13.512C3.3994 13.512 4.47187 13.512 5.54843 13.512C5.54843 12.9133 5.54843 12.3345 5.54843 11.7297ZM2.29557 15.179C2.29557 15.7114 2.27579 16.2269 2.3017 16.7403C2.32488 17.2066 2.74078 17.5325 3.20645 17.4664C3.53712 17.4193 3.86302 17.3368 4.19029 17.2653C4.64573 17.165 5.0998 17.06 5.54434 16.9598C5.54434 16.3462 5.54434 15.7694 5.54434 15.179C4.46437 15.179 3.39804 15.179 2.29557 15.179ZM26.8942 15.1851C25.7917 15.1851 24.7192 15.1851 23.64 15.1851C23.64 15.7823 23.64 16.3612 23.64 16.9694C24.4356 17.1391 25.2265 17.3293 26.0263 17.4691C26.4667 17.5462 26.8696 17.1814 26.8894 16.7246C26.9105 16.2187 26.8942 15.7114 26.8942 15.1851ZM13.7586 26.6509C13.7586 25.5484 13.7586 24.476 13.7586 23.396C13.1614 23.396 12.5832 23.396 11.9832 23.396C11.8271 24.0948 11.6703 24.7903 11.5162 25.4871C11.4944 25.5839 11.4753 25.6827 11.4678 25.7816C11.4344 26.2302 11.7623 26.627 12.2191 26.6461C12.725 26.6673 13.2323 26.6509 13.7586 26.6509ZM15.4222 26.6523C15.9506 26.6523 16.449 26.6652 16.9461 26.6482C17.4056 26.6325 17.7888 26.2425 17.7151 25.8062C17.5788 24.9975 17.3845 24.1985 17.2167 23.4062C16.5956 23.4062 16.0106 23.4062 15.4222 23.4062C15.4222 24.491 15.4222 25.558 15.4222 26.6523Z"
//         fill="var(--primary-color)"
//       />
//     </svg>
//   );
// };

const NotesIcon = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90114 6.12674C7.37025 6.12674 6.95312 5.69697 6.95312 5.17873V1.65212C6.95312 1.40069 7.053 1.15956 7.23079 0.981768C7.40858 0.803981 7.64971 0.704102 7.90114 0.704102C8.15257 0.704102 8.3937 0.803981 8.57148 0.981768C8.74927 1.15956 8.84915 1.40069 8.84915 1.65212V5.16609C8.84915 5.69697 8.43203 6.12674 7.90114 6.12674ZM17.2802 6.12674C16.7493 6.12674 16.3321 5.69697 16.3321 5.17873V1.65212C16.3321 1.40069 16.432 1.15956 16.6098 0.981768C16.7876 0.803981 17.0287 0.704102 17.2802 0.704102C17.5316 0.704102 17.7727 0.803981 17.9505 0.981768C18.1283 1.15956 18.2282 1.40069 18.2282 1.65212V5.16609C18.2282 5.69697 17.811 6.12674 17.2802 6.12674ZM24.5988 18.1728C24.5988 18.3624 24.5356 18.552 24.3713 18.7164L17.4066 25.7317C17.2422 25.9086 17.0273 25.9845 16.8125 25.9845C16.3953 25.9845 15.9909 25.6558 15.9909 25.1755V20.7514C15.9909 18.906 17.5582 17.3765 19.4795 17.3765C20.6804 17.3639 22.3489 17.3639 23.7772 17.3639C24.2702 17.3639 24.5988 17.7557 24.5988 18.1728Z"
        fill="var(--primary-color)"
      />
      <path
        d="M24.6021 18.1723C24.6021 18.3619 24.5389 18.5515 24.3746 18.7158L17.4098 25.7311C17.2455 25.908 17.0306 25.9839 16.8158 25.9839C16.3986 25.9839 15.9941 25.6552 15.9941 25.1749V20.7509C15.9941 18.9054 17.5615 17.3759 19.4828 17.3759C20.6836 17.3633 22.3522 17.3633 23.7805 17.3633C24.2735 17.3633 24.6021 17.7551 24.6021 18.1723Z"
        fill="var(--primary-color)"
      />
      <path
        d="M22.1608 3.8646C21.3265 3.24524 20.1257 3.83932 20.1257 4.88846V5.01486C20.1257 6.49376 19.0639 7.8589 17.585 8.01058C15.8786 8.18755 14.4376 6.84769 14.4376 5.17918V3.8646C14.4376 3.16939 13.8688 2.60059 13.1736 2.60059H12.0107C11.3155 2.60059 10.7467 3.16939 10.7467 3.8646V5.01486C10.7467 6.1272 10.1526 7.16369 9.22987 7.6693C9.17931 7.70722 9.12875 7.7325 9.07819 7.75778C9.06555 7.75778 9.06555 7.77042 9.05291 7.77042C8.96442 7.80834 8.87594 7.84626 8.77482 7.88418C8.74954 7.89682 8.72426 7.89682 8.69898 7.90946C8.5473 7.96002 8.38298 7.99794 8.20601 8.01058H8.19337C8.00377 8.03586 7.80153 8.03586 7.61193 8.01058H7.59928C7.42232 7.99794 7.258 7.96002 7.10632 7.90946C6.97992 7.87154 6.85351 7.82098 6.72711 7.75778C6.22954 7.5352 5.80714 7.17319 5.51102 6.71555C5.2149 6.25792 5.05776 5.72427 5.05861 5.17918V4.88846C5.05861 3.91516 4.02211 3.33372 3.2005 3.75084C3.18786 3.76348 3.17522 3.76348 3.16258 3.77612H3.14994C3.06146 3.83932 2.98562 3.90252 2.89714 3.96573C2.66114 4.15347 2.44127 4.36065 2.23985 4.58509C2.13873 4.68622 2.05025 4.78734 1.96176 4.9011C1.89856 4.97694 1.82272 5.05278 1.77216 5.14126C1.70896 5.2171 1.6584 5.30558 1.60784 5.38143C1.47944 5.56627 1.36535 5.76065 1.26655 5.96287C1.24127 5.98815 1.22863 6.00079 1.22863 6.02607C1.15279 6.17776 1.07695 6.32944 1.02639 6.49376C0.98847 6.55696 0.97583 6.60752 0.95055 6.67072C0.925269 6.72128 0.912629 6.78449 0.887349 6.83505C0.849428 6.96145 0.811508 7.10049 0.773587 7.23953C0.723026 7.41649 0.685106 7.6061 0.659825 7.7957C0.613868 8.11395 0.588535 8.43484 0.583984 8.75635V19.8292C0.583984 20.6375 0.743208 21.438 1.05256 22.1849C1.36192 22.9317 1.81535 23.6103 2.38697 24.1819C3.5414 25.3364 5.10714 25.9849 6.73975 25.9849H12.8323C13.5275 25.9849 14.0963 25.4161 14.0963 24.7209V20.7519C14.0963 17.8446 16.5106 15.4809 19.4811 15.4809C20.151 15.4683 21.7816 15.4683 23.3363 15.4683C24.0315 15.4683 24.6003 14.8995 24.6003 14.2043V8.75635C24.6003 6.74656 23.6397 4.98958 22.1608 3.8646ZM11.4925 18.2871C11.3787 18.6663 11.0248 18.9317 10.6076 18.9317H6.00662C5.94342 18.9317 5.89286 18.9317 5.8423 18.9064C5.62182 18.8742 5.42064 18.7627 5.2764 18.5929C5.13215 18.423 5.05473 18.2065 5.05861 17.9837C5.05861 17.4528 5.47573 17.023 6.00662 17.023H10.6076C11.1259 17.023 11.5557 17.4528 11.5557 17.9837C11.5557 18.0848 11.543 18.1986 11.4925 18.2871ZM15.0064 13.5975C14.8927 13.9767 14.5387 14.2422 14.1216 14.2422H6.00662C5.94342 14.2422 5.89286 14.2422 5.8423 14.2169C5.62182 14.1847 5.42064 14.0732 5.2764 13.9034C5.13215 13.7335 5.05473 13.517 5.05861 13.2942C5.05861 12.7633 5.47573 12.3335 6.00662 12.3335H14.1216C14.6525 12.3335 15.0696 12.7633 15.0696 13.2942C15.0696 13.3953 15.057 13.5091 15.0064 13.5975Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};

function Attednee() {
  const { item } = useLocation().state;

  // console.log(item);

  const attendeeDetails = [
    [
      {
        title: "Contact:",
        value: item?.contact_no,
        icon: <BsTelephone className={styles.callIcon} />,
      },
      {
        title: "Meal:",
        value: item?.meal?.map(
          (meal, i) =>
            `${meal.name} (${meal?.quantity})${
              i != item?.meal.length - 1 ? ", " : ""
            }`
        ),
        icon: <BiFoodMenu className={styles.callIcon} />,
      },
    ],
    [
      {
        title: "Email:",
        value: item?.email,
        icon: <IoMailOutline className={styles.callIcon} />,
      },
      {
        title: "Table:",
        value: item?.table_name,
        icon: <DiningIcon size={20} />,
      },
    ],
    [
      {
        title: "Address:",
        value: item?.address,
        icon: <LocIcon size={20} />,
      },
      {
        title: "Notes:",
        value: item?.notes,
        icon: <RiFileList3Line className={styles.callIcon} />,
      },
    ],
  ];

  const familyDetails = [
    { title: "Age:", value: item?.age_group },
    { title: "Group:", value: item?.guest_group },
    { title: "Attendance:", value: item?.status, valueTextPrimary: true },
  ];

  const renderTidbits = (item, i) => {
    return (
      <div className={styles.checklistMainCon} key={item?.id}>
        <div className={styles.checkHead}>
          <div className={styles.checklistContent}>
            <TextComponent text={i + 1} textClass={styles.checklistHead1} />
            <TextComponent
              text={item?.question}
              textClass={styles.checklistHead}
            />
            <div className={styles.checklistDate}>
              <TextComponent
                text={item?.answer?.map(
                  (ans, i) =>
                    `${ans}${i != item?.answer?.length - 1 ? ", " : ""}`
                )}
                textClass={styles.checklistDue}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.container}>
      <div className={styles.containerHeader}>
        <Row gutter={[8, 8]} className={styles.containerRow}>
          <Col xs={24} lg={6} className={styles.CR_left}>
            <TextComponent textClass={styles.containerH1}>
              {item?.name}
            </TextComponent>
            {/* <TextComponent textClass={styles.containerH2}>
              Makeup Artist
            </TextComponent> */}
          </Col>
          <Col xs={24} lg={18}>
            <Row gutter={[8, 16]} className={styles.CR_right}>
              {familyDetails.map((detail) => (
                <Col xs={24} sm={12} md={8} xl={6}>
                  <Row className={styles.detailRow}>
                    <TextComponent textClass={styles.row1TextTitle}>
                      {detail.title}{" "}
                    </TextComponent>
                    <TextComponent
                      textClass={
                        detail.valueTextPrimary
                          ? styles.row1TextValue2
                          : styles.row1TextValue
                      }
                    >
                      {" "}
                      {detail.value}
                    </TextComponent>
                  </Row>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
        {attendeeDetails?.map((detail) => (
          <Row className={styles.containerRow2} gutter={[8, 12]}>
            <Col xs={24} lg={10} xl={9}>
              <Row className={styles.innerRow}>
                <Col xs={24} sm={6} md={7} lg={8} xl={7}>
                  <Row gutter={8} className={styles.iconTextRow}>
                    {detail[0].icon}
                    <TextComponent textClass={styles.detailsTitle}>
                      {detail[0].title}
                    </TextComponent>
                  </Row>
                </Col>
                <Col>
                  <TextComponent textClass={styles.detailsValue}>
                    {detail[0].value}
                  </TextComponent>
                </Col>
              </Row>
            </Col>
            <Col xs={24} lg={12}>
              <Row className={styles.innerRow}>
                <Col xs={24} sm={6} md={7} lg={6} xl={4}>
                  <Row gutter={8} className={styles.iconTextRow}>
                    {detail[1].icon}
                    <TextComponent textClass={styles.detailsTitle}>
                      {detail[1].title}
                    </TextComponent>
                  </Row>
                </Col>
                <Col>
                  <TextComponent textClass={styles.detailsValue}>
                    {detail[1].value}
                  </TextComponent>
                </Col>
              </Row>
            </Col>
          </Row>
        ))}
      </div>
      <div className={styles.list}>
        <TextComponent className={styles.tidbitsHeading} text="Tidbits" />
        <List
          itemLayout="vertical"
          dataSource={item?.tidbits?.length > 0 ? item?.tidbits : []}
          renderItem={renderTidbits}
        />
      </div>
      {/* <Col className={styles.footer}>
        <TextComponent textClass={styles.footertitle}>
          Well Wishing
        </TextComponent>
        <TextComponent textClass={styles.footertitle1}>
          Certainly, here's a well-wishing note for James and Lucy's wedding
          party:
        </TextComponent>
        <TextComponent textClass={styles.footertitle1}>
          "Dear James and Lucy,
        </TextComponent>
        <TextComponent textClass={styles.footertitle1}>
          As you embark on this beautiful journey of love and togetherness, we
          want to extend our heartfelt congratulations to you. Your love story
          has always been an inspiration, and seeing you two unite in marriage
          fills our hearts with joy.
        </TextComponent>
        <TextComponent textClass={styles.footertitle1}>
          May your days be filled with endless laughter, shared dreams, and
          moments of deep connection. May you continue to support and uplift
          each other through all of life's ups and downs. Your love is a beacon
          of hope and a reminder that true happiness can be found in the company
          of a soulmate.
        </TextComponent>
        <TextComponent textClass={styles.footertitle1}>
          As you exchange your vows and begin this new chapter, remember that
          the journey ahead is best traveled hand in hand. May your love
          continue to grow stronger with each passing day, and may your bond be
          a source of strength and comfort.
        </TextComponent>
      </Col> */}
    </div>
  );
}

export default Attednee;
